import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Ahora organizo todo el año sin estrés. Es increíble el tiempo que ahorro.',
    author: 'Mariela S.',
    location: 'Córdoba, Argentina'
  }, {
    quote: 'Mis alumnos participan más y entienden mejor los procesos históricos. Me siento más segura enseñando.',
    author: 'Laura M.',
    location: 'Santa Fe, Argentina'
  }, {
    quote: 'Las clases cambiaron por completo. Todo está más claro y organizado.',
    author: 'Verónica P.',
    location: 'Buenos Aires, Argentina'
  }, {
    quote: 'Por fin tengo un recurso que realmente funciona para todos los grados. Mis compañeras me preguntan cómo hago para tener todo tan organizado.',
    author: 'Gabriela R.',
    location: 'Mendoza, Argentina'
  }, {
    quote: 'Lo mejor es que puedo adaptarlo a mi realidad. Mis alumnos disfrutan las clases de Sociales como nunca antes.',
    author: 'Carolina T.',
    location: 'Tucumán, Argentina'
  }];
  return <section className="bg-white py-16 px-4 md:px-8" data-id="element-206">
      <div className="max-w-6xl mx-auto" data-id="element-207">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-208">
          Testimonios de Maestras en Argentina
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-209">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col" data-id="element-210">
              <div className="flex gap-1 mb-4" data-id="element-211">
                {[...Array(5)].map((_, starI) => <Star key={starI} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-212" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-213">"{t.quote}"</p>
              <div className="mt-auto" data-id="element-214">
                <p className="font-bold text-gray-900" data-id="element-215">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-216">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}